import type { CreatePreRegistrationForm } from '../../interfaces/create-pre-registration-form';

type PreRegisterProfession = NonNullable<CreatePreRegistrationForm['profession']>;

export const PRE_REGISTER_PROFESSIONS: ReadonlyArray<{ value: PreRegisterProfession; label: string }> = [
	{ value: 'ARQUITETO(A)', label: 'Arquiteto(a)' },
	{ value: 'ENGENHERIO(A) CIVIL', label: 'Engenheiro(a)' },
	{ value: 'DESIGNER DE INTERIORES', label: 'Designer de interiores' },
] as const;

export const PRE_REGISTER_LGPD_LABEL =
	'Eu aceito receber informações, promoções e eventuais pesquisas da empresa Pormade. Os meus dados estão protegidos conforme a Lei Geral de Proteção de Dados - LGPD 13.709/18 e posso solicitar a exclusão a qualquer momento.';
